import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import exerciseEntityUpdated from '../actions/actionCreators/exerciseEntityUpdated';
import userWorkbookDeleted from '../actions/actionCreators/userWorkbookDeleted';
import userWorkbookUpdated from '../actions/actionCreators/userWorkbookUpdated';
import { jsx as ___EmotionJSX } from "@emotion/react";
const noProviderErrorFunction = () => {
  throw new Error('EntityContext cannot be used without being contained within an EntityProvider');
};
export const EntityContext = React.createContext({
  deleteUserWorkbook: noProviderErrorFunction,
  getExercise: noProviderErrorFunction,
  getUserWorkbook: noProviderErrorFunction,
  setExercise: noProviderErrorFunction,
  setUserWorkbook: noProviderErrorFunction
});
const EntityProvider = _ref => {
  let {
    children
  } = _ref;
  const dispatch = useDispatch();
  const exerciseEntities = useSelector(state => state.exerciseEntities);
  const userWorkbooks = useSelector(state => state.userWorkbooks);
  const getExercise = React.useCallback(exerciseId => exerciseEntities[exerciseId], [exerciseEntities]);
  const setExercise = React.useCallback((exerciseId, exerciseEntity) => {
    dispatch(exerciseEntityUpdated(exerciseId, exerciseEntity));
  }, [dispatch]);
  const getUserWorkbook = React.useCallback(workbookId => userWorkbooks[workbookId], [userWorkbooks]);
  const setUserWorkbook = React.useCallback((workbookId, userWorkbook) => {
    dispatch(userWorkbookUpdated(workbookId, userWorkbook));
  }, [dispatch]);
  const deleteUserWorkbook = React.useCallback(workbookId => {
    dispatch(userWorkbookDeleted(workbookId));
  }, [dispatch]);
  return ___EmotionJSX(EntityContext.Provider, {
    value: {
      deleteUserWorkbook,
      getExercise,
      getUserWorkbook,
      setExercise,
      setUserWorkbook
    }
  }, children);
};
export default EntityProvider;